'use strict';

/**
 * @ngdoc directive
 * @name gfcmsApp.directive:lockscreen.directive
 * @description
 * # lockscreen.directive
 */
angular.module('gfcmsApp')
  .directive('lockscreenWidget', function($document) {
    return {
      templateUrl: '/views/lockscreen.html',
      restrict: 'EA',
      link: function postLink(scope, element, attrs) {
        scope.lockScreen = lockScreen;
        scope.unlock = unlock;
        scope.format = 'h:mm:ss a';

        scope.lock = false;

        function lockScreen() {
          scope.lock = true;
        }

        function unlock() {
          scope.lock = false;
          scope.unlockPassword = '';
          $document.find('.modal-backdrop').remove();
          $document.find('body').removeClass('modal-open');
          $document.find('modal-dialog').removeClass('modal-in');
        }
      }
    };
  });
